// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/order_item_requests/lista/{order_item_id}
 *
 * Returns all customer requests for an order item, ordered by
 * display_order. Wire shape: `dados: Order_item_requests_OirRow[]`.
 *
 * @see Order_item_requests_OirRow
 * @see So_order_item_requests_model::listByOrderItem()
 */
import type { Order_item_requests_OirRow } from './Order_item_requests_OirRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Order_item_requests_ListaResponseDados = Order_item_requests_OirRow[];

export type Order_item_requests_ListaResponse = ApiResponse<Order_item_requests_ListaResponseDados>;

registerResponseContract('Order_item_requests_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_oir_id:                { type: 'number',  required: true },
      so_oir_order_item_id:     { type: 'number',  required: true },
      so_oir_description:       { type: 'string',  required: true },
      so_oir_photo:             { type: 'string',  required: false },
      so_oir_verified:          { type: 'number',  required: true },
      so_oir_verified_at:       { type: 'string',  required: false },
      so_oir_verified_by:       { type: 'string',  required: false },
      so_oir_exit_confirmed:    { type: 'number',  required: false },
      so_oir_exit_confirmed_at: { type: 'string',  required: false },
      so_oir_exit_confirmed_by: { type: 'string',  required: false },
      so_oir_exit_photo:        { type: 'string',  required: false },
      so_oir_display_order:     { type: 'number',  required: true },
      so_oir_created_at:        { type: 'string',  required: true },
    },
  },
})
